export default "__VITE_ASSET__Dx7ylYn9__"